import { ThemeProvider } from "@mui/material/styles";
import { GlobalProvider } from "./context/Provider";
import { CssBaseline } from "@mui/material";
import { theme } from "./theme";
import Routing from "./routing/Routing";
import { SnackbarProvider } from "notistack";

function App() {
  return (
    <div className={"app"}>
      <GlobalProvider>
        <ThemeProvider theme={theme}>
          <SnackbarProvider
            anchorOrigin={{
              horizontal: "center",
              vertical: "top",
            }}
          >
            <CssBaseline />
            <Routing />
          </SnackbarProvider>
        </ThemeProvider>
      </GlobalProvider>
    </div>
  );
}

export default App;
